import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import {inventarioResources} from "../endpoints";

class DialogAnalistaResponsable extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            title: props.title,
            analista: "",
            coordinador: '',
            rowData: props.rowData,
            titulo_1: 'Analista responsable',
            titulo_2: 'Coordinador responsable',
        }
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    modificaAnalista = ()=>{
        let folio = this.state.rowData.folio
        inventarioResources.modificarAnalistaCoordinadorResponsable(folio, this.state.analista, this.state.coordinador).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.props.refrescar(result)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            let result ={
                message:"Ha ocurrido un error inesperado",
                severity: "error",
                status_code: 400
            }
            this.props.refrescar(result)
            console.log(error)
        });

    }
    componentDidMount() {
        if (this.state.rowData.cliente === "WALMART" || this.state.rowData.cliente === "WALMART PARCIALES" ){
                this.setState({titulo_1:"Analista responsable cliente", titulo_2: "Supervisor SCA"})
        }
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            {this.state.titulo_1}: <TextField value={this.state.analista} autoFocus={true} name="analista" fullWidth onChange={this.handleChange}/>
                        </Grid>
                        <Grid item xs={12}>
                            {this.state.titulo_2}: <TextField value={this.state.coordinador} name="coordinador" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.analista || !this.state.coordinador} variant="contained" onClick={this.modificaAnalista} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAnalistaResponsable;